import React, { useState, useEffect } from "react";
import "./publication.css"; // We'll use our own CSS file instead of Bootstrap
// import PublicationModal from "./publicationModal";
import { Modal, Button, Form, Row, Col, Container } from 'react-bootstrap';
import {
    addPublication,
    deletePublication,
    getPublication,
    getProject,
    updatePublication,
    getAllDataWithFlag
} from "../../../../services/CommonService";
import Swal from "sweetalert2";
import { exportToExcel } from "../../../../Utils/common-Excel";
import ThemeTypoModal from "../Project/ThemetypoModal";

import PublicationAssetInput from './PublicationAssetInput';

const Publication = () => {
    const initialFormState = {
        title: "",
        description: "",
        type: "",
        typology: "",
        state: "",
        district: "",
        country: "",
        year: "",
        project_id: "",
        thumbnail: null,
        file: null,
        link: ''
    };
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        type: "",
        typology: "",
        state: "",
        district: "",
        country: "",
        year: "",
        project_id: "",
        thumbnail: null,
        file: null,
        link: ''
    });

    const getContentTypeName = (code) => {
        const match = typeofContent.find(t => String(t.LookupCode) === String(code));
        return match ? match.LookupValue : code; // fallback to code if not found
    };
    const getTypeName = (code) => {
        const match = typeoftypology.find(t => String(t.LookupCode) === String(code));
        return match ? match.LookupValue : code; // fallback to code if not found
    };
    const getTypeMode = (code) => {
        const match = typeofMode.find(t => String(t.LookupCode) === String(code));
        return match ? match.LookupValue : code; // fallback to code if not found
    };

    const getProject = (id) => {
        return projectData.find((p) => p.id === id);
    };

    // excel download
    const handleDownloadExcel = () => {
        const formatDate = (isoString) => {
            const date = new Date(isoString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        };
        const exportData = filteredItems?.map((item, index) => {
            const project = item.project_id ? getProject(item.project_id) : null;
            return {
                "S.No": index + 1,
                Title: item.title,
                Type: getContentTypeName(item.type),
                Typology: getTypeName(item.typology),
                Country: item.countryName,
                State: item.stateName,
                District: item.districtName,
                Year: item.year,
                Mode: getTypeMode(item.link),
                File: item.file,
                Thumbnail: item.thumbnail,
                Project: project?.title || null,
                "Created on": formatDate(item.created_at),
                "Updated on": formatDate(item.updated_at)
            }
        });
        exportToExcel(exportData, 'PublicationList', 'Publication', 'Publication Report', null, null);
    };

    const [CountryData, setCountryData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showAddForm, setShowAddForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [publications, setPublication] = useState([]);
    const [items, setItems] = useState([]);
    const [selectedPublicationId, setSelectedPublicationId] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [StateData, setStateData] = useState([]);
    const [DistrictData, setDistrictData] = useState([]);
    const [typologyData, setTypologyData] = useState([]);
    const [projectData, setProjectData] = useState([]);
    const [filteredStateData, setFilteredStateData] = useState([]); // For dropdown
    const [filteredDistrictData, setfilterDistrictData] = useState([]); // For dropdown
    // const [typeofMode, setTypeofMode] = useState("");
    const [typeofMode, setTypeofMode] = useState([]);
    const [typeofContent, setTypeofContent] = useState("");
    const [validated, setValidated] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [totalPages, setTotalPages] = useState(1);
    const [filteredItems, setFilteredItems] = useState([]);
    const [selectedData, setSelectedData] = useState([]);
    const [showViewModal, setShowViewModal] = useState(false);
    const [tyData, setTypoData] = useState([]);
    const [typeoftypology, setTypeofTypology] = useState([]);
    const [fileError, setFileError] = useState("");
    const [thumbnailError, setThumbnailError] = useState("");
    const [paginatedItems, setPaginatedItems] = useState([]);

    // Fetch existing projects data
    useEffect(() => {
        setFormData(initialFormState); // Reset form
        const typologyDa = JSON.parse(localStorage.getItem('lookup'));
        const typoData = JSON.parse(localStorage.getItem('typologyData'));
        setTypoData(typoData || [])
        const Datacountrystatedistrict = JSON.parse(localStorage.getItem('StateMaster') || '{}');
        if (Datacountrystatedistrict) {
            setCountryData(Datacountrystatedistrict.country || []);
            setStateData(Datacountrystatedistrict.state || []);
            setDistrictData(Datacountrystatedistrict.district || []);
        }
        setTypeofContent(typologyDa.filter((m) => m.Flag == '4'));
        setTypeofMode(typologyDa.filter((m) => m.Flag == '7'))
        setTypeofTypology(typologyDa.filter((m) => m.Flag == '3'))
        setTypologyData(typologyDa || []);
    }, []);

    useEffect(() => {
        if (CountryData.length && StateData.length && DistrictData.length) {
            fetchPublication();
        }
    }, [CountryData, StateData, DistrictData]);

    useEffect(() => {
        setFilteredItems(publications);
        setTotalPages(Math.ceil(publications.length / itemsPerPage));
    }, [publications, itemsPerPage]);

    useEffect(() => {
        filterAndPaginateItems();
    }, [searchTerm, currentPage, publications, itemsPerPage]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name == "type" && value == 2) formData.link = 2;
        setFormData((prev) => ({
            // ...prev
            ...formData,
            [name]: value,
            ...(name === 'country' && { state: '', district: '' }) // Reset state if country changes
        }));
        if (name == 'country') {
            const filtered = StateData.filter(
                (state) => state?.country_id != null && state.country_id == value
            );
            const sortedState = filtered.sort((a, b) =>
                a.statename.trim().localeCompare(b.statename.trim())
            );
            setFilteredStateData(sortedState);
        }
        if (name === 'state') {
            const filteredDistrict = DistrictData.filter(
                (district) => district.id_mststate == value
            );
            const sortedDistricts = filteredDistrict.sort((a, b) =>
                a.districtname.trim().localeCompare(b.districtname.trim())
            );
            setfilterDistrictData(sortedDistricts);
        }
    };

    const filteredPublications = publications.filter((pub) =>
        pub.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Filter and paginate gallery items
    const filterAndPaginateItems = () => {
        const filtered = publications.filter(
            (item) =>
                (item.title || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
                (item.countryName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
                (item.stateName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
                (item.districtName || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.year?.toString().includes(searchTerm)
        );

        setFilteredItems(filtered); // full list for total count
        setTotalPages(Math.ceil(filtered.length / itemsPerPage));

        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;

        const paginated = filtered.slice(indexOfFirstItem, indexOfLastItem);
        setPaginatedItems(paginated); // ✅ store separately
    };

    const handleTypologyInfoClick = () => {
        setShowViewModal(true);
    }

    // Get Data
    const fetchPublication = async () => {
        try {
            setLoading(true);
            const response = await getAllDataWithFlag(4);
            const response1 = await getAllDataWithFlag(5);
            if (response.status != 200) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const data = response?.data.publication;
            const activeItems = data.filter(item => item.is_deleted === null);
            const mergedArray = activeItems.map(item => {
                const matchedCountry = CountryData.find(country => country.id == item.country);
                const matchedState = StateData.find(state => state.id_mststate == item.state);
                const matchedDistrict = DistrictData.find(dis => dis.id_mstdistrict == item.district);
                return {
                    ...item,
                    countryName: matchedCountry ? matchedCountry.CountryName : null,
                    stateName: matchedState ? matchedState.statename : null,
                    districtName: matchedDistrict ? matchedDistrict.districtname : null
                };
            });
            setPublication(mergedArray)
            setProjectData(response1.data.project);
            setLoading(false);
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: error?.response?.data?.message || error?.message,
                icon: "error",
                confirmButtonText: "OK",
            });
            setLoading(false);
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];
            if (!allowedTypes.includes(file.type)) {
                setFileError("Only JPEG, PNG, JPG, or PDF files are allowed.");
                setFormData({ ...formData, file: null }); // clear the invalid file
            } else {
                setFileError(""); // clear error
                setFormData({ ...formData, file }); // set the valid file
            }
        }
    };

    // Declare this near the top inside your functional component
    const handleFileChange1 = (e) => {
        const file = e.target.files[0];
        if (file) {
            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!allowedTypes.includes(file.type)) {
                setThumbnailError("Only JPEG, PNG, or JPG files are allowed.");
                setFormData((prev) => ({ ...prev, thumbnail: null })); // note: use `thumbnail` here
            } else {
                setThumbnailError("");
                setFormData((prev) => ({ ...prev, thumbnail: file }));
            }
        }
    };

    // Add
    const add = (data) => {
        setShowAddForm(!showAddForm)
        setSelectedPublicationId(data);
        if (data) {
            loadProjectData(data);
        }
    };

    // load publication
    const loadProjectData = (project) => {
        const filtered = StateData.filter(
            (state) => state?.country_id != null && state.country_id == project.country
        );
        const filteredDistrict = DistrictData.filter(
            (district) => district.id_mstdistrict == project.district
        );
        setfilterDistrictData(filteredDistrict);
        setFilteredStateData(filtered);
        setFormData({
            title: project.title || "",
            description: project.description || "",
            type: project.type || "",
            typology: project.typology || "",
            state: project.state || "",
            district: project.district || "",
            country: project.country || "",
            year: project.year || "",
            thumbnail: project.thumbnail || null,
            file: project.file || null,
            project_id: project.project_id || "",
            link: project.link || "",
        });
    };

    // chane mode 
    const selectedModeLabel = Array.isArray(typeofMode)
        ? typeofMode.find(item => item.LookupCode == formData.link)?.LookupValue
        : "";

    const isValidURL = (url) => {
        try {
            new URL(url);
            return true;
        } catch (error) {
            return false;
        }
    };

    // Submit Upload Form
    const handleSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        if ((form.checkValidity() === false)) {
            setValidated(true); // trigger validation UI
            return;
        }
        setValidated(false);
        setLoading(true);
        setMessage("");
        if (formData.linkUrl && !isValidURL(formData.linkUrl)) {
            Swal.fire({
                title: "Error",
                text: "Please enter a valid URL",
                icon: "error",
                confirmButtonText: "OK",
            });
            return
        };
        if (fileError) {
            Swal.fire({
                title: "Error",
                text: "Validation Error!",
                icon: "error",
                confirmButtonText: "OK",
            });
            return
        };
        if (!(formData.file instanceof File)) {
            delete formData.file;
        }
        if (!(formData.thumbnail instanceof File)) {
            delete formData.thumbnail;
        }
        const publicationform = new FormData();
        Object.keys(formData).forEach((key) => {
            const value = formData[key];
            if (value !== null) {
                publicationform.append(key, value);
                if (key === 'linkUrl' && value) {
                    publicationform.append('file', value);
                }
            }
        });

        const formDataToSend = new FormData();
        formDataToSend.append("title", formData.title);
        if (formData.file instanceof File) {
            formDataToSend.append("file", formData.file);
        }
        try {
            let response;
            if (selectedPublicationId?.id) {
                response = await updatePublication(publicationform, selectedPublicationId?.id);
            } else {
                response = await addPublication(publicationform);
            }
            if (response.status == 200 || response.status == 201) {
                setShowAddForm(!showAddForm)
                fetchPublication();
                Swal.fire({
                    title: "Success!",
                    text: `${selectedPublicationId ? "Publication updated successfully!" : "Publication created successfully!"}`,
                    icon: "success",
                    confirmButtonText: "OK",
                });
            } else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            // Operation completed successfully
            setMessage(
                selectedPublicationId
                    ? "Publication updated successfully!"
                    : "Publication created successfully!"
            );
            setSelectedPublicationId(null);
            // Reset form
            setFormData({
                title: "",
                description: "",
                type: "",
                typology: "",
                state: "",
                district: "",
                country: "",
                year: "",
                project_id: "",
                thumbnail: null,
                file: null
            });
        } catch (error) {
            console.error("Error handling", error)
            Swal.fire({
                title: "Error",
                text: error?.response?.data?.message || error?.message,
                icon: "error",
                confirmButtonText: "OK",
            });
            console.error("Error handling publication:", error?.response?.statusText
            );
        } finally {
            setLoading(false);
        }
    };

    // Handle search input changes
    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to first page when searching
    };

    // delete 
    const handleDelete = async (publications) => {
        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to delete this item?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await deletePublication(publications.id);  // `deleteBanner` is the API function
                    if (response.status === 200) {
                        Swal.fire({
                            title: 'Success!',
                            text: response.data.message,
                            icon: 'success',
                            confirmButtonText: 'ok'
                        });
                        fetchPublication();
                        setItems(prevItems => prevItems.filter(i => i.id !== publications.id));  // Remove deleted item from the list
                    } else {
                        console.error('Failed to delete item:', response.data.message || 'Unknown error');
                        Swal.fire({
                            title: 'error',
                            text: response.data.message,
                            icon: 'error',
                            confirmButtonText: 'ok'
                        });
                    }
                } catch (error) {
                    Swal.fire({
                        title: 'error',
                        text: error?.response?.data?.message || error?.message,
                        icon: 'error',
                        confirmButtonText: 'ok'
                    });
                }
            }
        });
    };

    const Pagination = ({ currentPage, totalPages, onPageChange, onItemsPerPageChange }) => {
        return (
            <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="d-flex align-items-center">
                    <span className="me-2">Items per page:</span>
                    <select
                        className="form-select form-select-sm"
                        style={{ width: "70px" }}
                        value={itemsPerPage}
                        onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
                    >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                    </select>
                </div>

                <nav aria-label="Gallery pagination">
                    <ul className="pagination pagination-sm mb-0">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <button
                                className="page-link"
                                onClick={() => onPageChange(currentPage - 1)}
                                disabled={currentPage === 1}
                            >
                                Previous
                            </button>
                        </li>

                        {[...Array(totalPages).keys()].map(number => (
                            <li
                                key={number + 1}
                                className={`page-item ${currentPage === number + 1 ? 'active' : ''}`}
                            >
                                <button
                                    className="page-link"
                                    onClick={() => onPageChange(number + 1)}
                                >
                                    {number + 1}
                                </button>
                            </li>
                        ))}

                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                            <button
                                className="page-link"
                                onClick={() => onPageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}
                            >
                                Next
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>
        );
    };

    return (
        // <div className="admin-portal-container">
        <div className="container-fluid mt-4">
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-header adminCardHeader d-flex-between">
                            <h4>
                                {showAddForm
                                    ? selectedPublicationId?.id
                                        ? 'Update Publication'
                                        : 'Add New Publication'
                                    : 'Publication List'}
                            </h4>
                            <button
                                onClick={() => {
                                    if (!showAddForm) {
                                        setFormData({
                                            title: "",
                                            description: "",
                                            type: "",
                                            typology: "",
                                            state: "",
                                            district: "",
                                            country: "",
                                            year: "",
                                            project_id: "",
                                            thumbnail: null,
                                            file: null,
                                            link: ''
                                        });
                                    }
                                    setShowAddForm(!showAddForm);
                                    setSelectedPublicationId(null)
                                }}
                                className={`btn btn-sm btn-warning`}
                            >
                                <i className={`bi ${showAddForm ? 'bi-arrow-left' : 'bi-plus-circle'} me-1`}></i>
                                {showAddForm ? 'Back' : 'Add New Publication'}
                            </button>

                        </div>
                        {!showAddForm ? (
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6 ">
                                        <div className="d-flex justify-content-start align-items-center">
                                            <label className="me-2">Search:</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                value={searchTerm}
                                                onChange={handleSearch}
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="d-flex justify-content-end align-items-center">
                                            <button className="btn btn-success mb-2" onClick={handleDownloadExcel}>
                                                <i className="bi bi-file-earmark-excel-fill me-2"></i>
                                                Excel
                                            </button>
                                        </div>
                                    </div>

                                </div>
                                {loading && <p className="text-center">Loading Publication...</p>}
                                {publications.length === 0 && !loading ? (
                                    <p className="text-center">No publication found.</p>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Title</th>
                                                    <th>Country</th>
                                                    <th>State</th>
                                                    <th>District</th>
                                                    <th>Year</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paginatedItems.map((project) => (
                                                    <tr key={project.id}>
                                                        <td>{project.title}</td>
                                                        <td>{project.countryName}</td>
                                                        <td>{project.stateName}</td>
                                                        <td>{project.districtName}</td>
                                                        <td>{project.year}</td>
                                                        <td>
                                                            <i className='bi-delete-fill'></i>
                                                            <i className="bi bi-pencil-fill text-primary me-2" style={{ cursor: 'pointer' }} onClick={() => add(project)}></i>
                                                            <i className="bi bi-trash-fill text-danger" style={{ cursor: 'pointer' }} onClick={() => handleDelete(project)}></i>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                )}
                                <Pagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={(page) => setCurrentPage(page)}
                                    onItemsPerPageChange={(size) => {
                                        setItemsPerPage(size);
                                        setCurrentPage(1); // Reset to first page when changing items per page
                                    }}
                                />
                            </div>
                        ) : (
                            <div className="card-body">
                                <Form onSubmit={handleSubmit} noValidate validated={validated}>
                                    <Row className="mb-3">
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Title<span className="text-danger">*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="title"
                                                    placeholder="Enter title"
                                                    value={formData.title}
                                                    onChange={handleInputChange}
                                                    className="shadow-sm"
                                                    required
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    Title is required.
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Type<span className="text-danger">*</span></Form.Label>
                                                <Form.Select
                                                    as="select"
                                                    name="type"
                                                    required
                                                    isInvalid={validated && !formData.type}
                                                    value={formData.type}
                                                    onChange={handleInputChange}>
                                                    <option value="">Select type</option>
                                                    {typeofContent.map((typo) => (
                                                        <option key={typo.LookupCode} value={typo.LookupCode}>
                                                            {typo.LookupValue}
                                                        </option>
                                                    ))}
                                                    <option value="3">PDF</option>
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select a type.
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>
                                                    <span className="me-2">
                                                        Typology <span className="text-danger">*</span>
                                                    </span>
                                                    <i
                                                        className="bi bi-info-circle text-primary"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={handleTypologyInfoClick}
                                                    ></i>
                                                </Form.Label>
                                                <Form.Select
                                                    name="typology"
                                                    required
                                                    isInvalid={validated && !formData.typology}
                                                    value={formData.typology}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="">Select typology</option>
                                                    {typologyData
                                                        .filter((typo) => typo.Flag == 3)
                                                        .sort((a, b) => a.LookupValue.localeCompare(b.LookupValue))
                                                        .map((typo) => (
                                                            <option key={typo.LookupCode} value={typo.LookupCode}>
                                                                {typo.LookupValue}
                                                            </option>
                                                        ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select typology
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Country<span className="text-danger">*</span></Form.Label>
                                                <Form.Select
                                                    as="select"
                                                    name="country"
                                                    required
                                                    isInvalid={validated && !formData.country}
                                                    value={formData.country}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="">Select country</option>
                                                    {CountryData.map((country) => (
                                                        <option key={country.id} value={country.id}>
                                                            {country.CountryName}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select country
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                                                <Form.Select
                                                    as="select"
                                                    name="link"
                                                    required
                                                    isInvalid={validated && !formData.link}
                                                    value={formData.link}
                                                    disabled={formData.type == 2}
                                                    onChange={handleInputChange}>
                                                    <option value="">Select mode</option>
                                                    {typeofMode.map((typo) => (
                                                        <option key={typo.LookupCode} value={typo.LookupCode}>
                                                            {typo.LookupValue}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select mode
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>
                                                    {selectedModeLabel === "Link" ? "URL" : "File"} <span className="text-danger">*</span>
                                                </Form.Label>
                                                {selectedModeLabel === "Link" ? (
                                                    <Form.Control
                                                        type="text"
                                                        name="linkUrl"
                                                        value={formData.linkUrl || ""}
                                                        onChange={handleInputChange}
                                                        placeholder="Enter URL"
                                                        required
                                                    />
                                                ) : (
                                                    <PublicationAssetInput
                                                        name="file"
                                                        value={formData.file}
                                                        folder="files"
                                                        label="File"
                                                        onChange={handleFileChange}
                                                        error={fileError}
                                                    />
                                                )}
                                                {selectedModeLabel === "Link" && (
                                                    <Form.Control.Feedback type="invalid">
                                                        Please enter a URL
                                                    </Form.Control.Feedback>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        {/* <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>State</Form.Label>
                                                <Form.Select
                                                    as="select"
                                                    name="state"
                                                    value={formData.state}
                                                    disabled={formData.country != 1}
                                                    onChange={handleInputChange}>
                                                    <option value="">Select state</option>
                                                    {filteredStateData.map((state) => (
                                                        <option key={state.id_mststate} value={state.id_mststate}>
                                                            {state.statename}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>District</Form.Label>
                                                <Form.Select
                                                    as="select"
                                                    name="district"
                                                    value={formData.district}
                                                    onChange={handleInputChange}
                                                    disabled={formData.country != 1} >
                                                    <option value="">Select district</option>
                                                    {filteredDistrictData.map((district) => (
                                                        <option key={district.id_mstdistrict} value={district.id_mstdistrict}>
                                                            {district.districtname}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col> */}
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Thumbnail<span className="text-danger">*</span></Form.Label>
                                                <PublicationAssetInput
                                                    name="thumbnail"
                                                    value={formData.thumbnail}
                                                    folder="thumbnails"
                                                    label="Thumbnail"
                                                    onChange={handleFileChange1}
                                                    error={thumbnailError}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Year</Form.Label>
                                                <Form.Select
                                                    name="year"
                                                    value={formData.year}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="">Select Year</option>
                                                    {Array.from({ length: 50 }, (_, i) => {
                                                        const year = new Date().getFullYear() - i;
                                                        return (
                                                            <option key={year} value={year}>
                                                                {year}
                                                            </option>
                                                        );
                                                    })}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Project <span className="text-danger">*</span></Form.Label>
                                                <Form.Select
                                                    as="select"
                                                    name="project_id"
                                                    value={formData.project_id}
                                                    required={!formData.project_id}
                                                    onChange={handleInputChange}>
                                                    <option value="">Select project</option>
                                                    {projectData?.map((proj) => (
                                                        <option key={proj?.id} value={proj?.id}>
                                                            {proj?.title}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {thumbnailError || "Please select Program"}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Label>Description</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    name="description"
                                                    value={formData.description}
                                                    onChange={handleInputChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <div className="col-12 mt-4 text-end">
                                        <Button type="submit" className="btn btn-sm btn-warning me-2">
                                            Submit
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {showViewModal && (
                <ThemeTypoModal selectionType={'Typology'} selectedData={tyData} setShowViewModal={setShowViewModal} />
            )}
        </div>
    );
};

export default Publication;
